module.exports = __webpack_public_path__ + "img/home_slide_03.5b49a7b6.png";